import { useState } from "react";
import { Tooltip, Modal, Button, Text, ActionIcon, Flex, Title } from "@mantine/core";
import { IconDots } from "@tabler/icons-react";

interface OrderListProps {
    orders: string[];
    title?: string;
}
const OrderList = ({ orders, title }: OrderListProps) => {
  const [opened, setOpened] = useState(false);
  const displayedOrder = orders[0]; // Chỉ hiển thị đơn hàng đầu tiên
  const hasMore = orders.length > 1;

  return (
    <>
      <Tooltip label={orders.join(", ")}>
        <Flex gap={6} align="center">
          <p style={{ margin: 0 }}>{displayedOrder}</p>
          {hasMore && (
            <ActionIcon
              color="blue"
              radius="xl"
              variant="light"
              aria-label="Settings"
              onClick={() => setOpened(true)}
            >
              <IconDots size="1.2rem" />
            </ActionIcon>
          )}
        </Flex>
      </Tooltip>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title={<Title order={4}>{title}</Title>}
      >
        {orders.map((order, index) => (
          <Text mt={5} key={index}>{order}</Text>
        ))}
      </Modal>
    </>
  );
};

export default OrderList;
